class GlobalReviews extends HTMLElement {
  constructor() {
    super();

    this.el = this;
    this.sectionId = this.el.getAttribute('id');
    this.subscriberId = window.okendoCustomSidebarConfig?.subscriberId;
    this.nextUrl = null;
    this.basePath = 'https://api.okendo.io/v1';
    this.desktopModal = document.querySelector('#PopupModal-reviews-header-featured-reviews-badge-desktop');
    this.mobileButton = document.querySelector('#header-featured-reviews-badge-mobile');

    this.allReviews = [];
    this.availableLanguages = [
      'zh',
      'cs',
      'da',
      'nl',
      'en',
      'fr',
      'de',
      'id',
      'it',
      'ja',
      'ko',
      'pl',
      'pt',
      'ru',
      'es',
      'sv',
      'th',
      'vi',
    ];

    this.locale = this.availableLanguages.includes(Shopify.locale) ? Shopify.locale : 'en';
    this.reviewsFetched = false;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    if (this.desktopModal) {
      new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
            if (this.desktopModal.hasAttribute('open') && !this.reviewsFetched) {
              this.loadReviews();
            }
          }
        });
      }).observe(this.desktopModal, { attributes: true, attributeFilter: ['open'] });
    }

    this.mobileEventListener();
  }

  async loadReviews() {
    try {
      this.showInitialLoader();
      this.showAttributeLoader();
      this.allReviews = await this.fetchAllReviews();
      const attributeAggregates = this.aggregateAttributeRatings(this.allReviews);
      await this.fetchReviews();
      this.displayAttributeRatings(attributeAggregates);
      this.initializeLoadMore();
      this.reviewsFetched = true;
    } catch (err) {
      console.error('Failed to load reviews:', err);
    }
  }

  showAttributeLoader() {
    const containers = document.querySelectorAll('.rating-attributes');
    containers.forEach((container) => {
      container.innerHTML = `
      <div class="reviews-loader">
        <div class="reviews-loader__spinner">
          <span class="visually-hidden">${window.reviewStrings.loading_reviews}</span>
        </div>
      </div>
    `;
    });
  }

  mobileEventListener() {
    if (!this.mobileButton) return;
    this.mobileButton.addEventListener('click', () => {
      this.desktopModal.show();
    });
  }

  showInitialLoader() {
    this.isInitialLoading = true;
    const reviewsListElement = document.getElementById(`reviews-list-${this.sectionId}`);

    if (reviewsListElement) {
      reviewsListElement.innerHTML = `
        <div class="reviews-loader">
          <div class="reviews-loader__spinner">
            <span class="visually-hidden">${window.reviewStrings.loading_reviews}</span>
          </div>
        </div>
      `;
    }
  }

  hideInitialLoader() {
    this.isInitialLoading = false;
    const loaderElements = document.querySelectorAll('.reviews-loader');
    loaderElements.forEach((loader) => {
      loader.remove();
    });
  }

  renderStar(type) {
    switch (type) {
      case 'full':
        return `<svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.04894 0.927049C8.3483 0.00573802 9.6517 0.00574017 9.95106 0.927051L11.2451 4.90983C11.379 5.32185 11.763 5.60081 12.1962 5.60081H16.3839C17.3527 5.60081 17.7554 6.84043 16.9717 7.40983L13.5838 9.87132C13.2333 10.126 13.0866 10.5773 13.2205 10.9894L14.5146 14.9721C14.8139 15.8934 13.7595 16.6596 12.9757 16.0902L9.58778 13.6287C9.2373 13.374 8.7627 13.374 8.41221 13.6287L5.02426 16.0902C4.24054 16.6596 3.18607 15.8934 3.48542 14.9721L4.7795 10.9894C4.91338 10.5773 4.76672 10.126 4.41623 9.87132L1.02827 7.40983C0.244561 6.84043 0.647338 5.60081 1.61606 5.60081H5.8038C6.23703 5.60081 6.62099 5.32185 6.75486 4.90983L8.04894 0.927049Z" fill="#FEC926"/>
        </svg>`;
      case 'empty':
        return `<svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.04894 0.927049C8.3483 0.00573802 9.6517 0.00574017 9.95106 0.927051L11.2451 4.90983C11.379 5.32185 11.763 5.60081 12.1962 5.60081H16.3839C17.3527 5.60081 17.7554 6.84043 16.9717 7.40983L13.5838 9.87132C13.2333 10.126 13.0866 10.5773 13.2205 10.9894L14.5146 14.9721C14.8139 15.8934 13.7595 16.6596 12.9757 16.0902L9.58778 13.6287C9.2373 13.374 8.7627 13.374 8.41221 13.6287L5.02426 16.0902C4.24054 16.6596 3.18607 15.8934 3.48542 14.9721L4.7795 10.9894C4.91338 10.5773 4.76672 10.126 4.41623 9.87132L1.02827 7.40983C0.244561 6.84043 0.647338 5.60081 1.61606 5.60081H5.8038C6.23703 5.60081 6.62099 5.32185 6.75486 4.90983L8.04894 0.927049Z" fill="#E5E5E5"/>
        </svg>`;
      case 'half':
        return `<svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="half-star-${this.sectionId}">
              <stop offset="50%" stop-color="#FEC926"/>
              <stop offset="50%" stop-color="#E5E5E5"/>
            </linearGradient>
          </defs>
          <path d="M8.04894 0.927049C8.3483 0.00573802 9.6517 0.00574017 9.95106 0.927051L11.2451 4.90983C11.379 5.32185 11.763 5.60081 12.1962 5.60081H16.3839C17.3527 5.60081 17.7554 6.84043 16.9717 7.40983L13.5838 9.87132C13.2333 10.126 13.0866 10.5773 13.2205 10.9894L14.5146 14.9721C14.8139 15.8934 13.7595 16.6596 12.9757 16.0902L9.58778 13.6287C9.2373 13.374 8.7627 13.374 8.41221 13.6287L5.02426 16.0902C4.24054 16.6596 3.18607 15.8934 3.48542 14.9721L4.7795 10.9894C4.91338 10.5773 4.76672 10.126 4.41623 9.87132L1.02827 7.40983C0.244561 6.84043 0.647338 5.60081 1.61606 5.60081H5.8038C6.23703 5.60081 6.62099 5.32185 6.75486 4.90983L8.04894 0.927049Z" fill="url(#half-star-${this.sectionId})"/>
        </svg>`;
    }
  }

  renderStars(averageRating) {
    const fullStars = Math.floor(averageRating);
    const hasHalfStar = averageRating % 1 >= 0.5;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    let starsHTML = '';

    // Full stars
    for (let i = 0; i < fullStars; i++) {
      starsHTML += this.renderStar('full');
    }

    // Half star
    if (hasHalfStar) {
      starsHTML += this.renderStar('half');
    }

    // Empty stars
    for (let i = 0; i < emptyStars; i++) {
      starsHTML += this.renderStar('empty');
    }

    return starsHTML;
  }

  async fetchAllReviews() {
    let reviews = [];
    let next = null;
    let fetchedCount = 0;
    const SUMMARY_LIMIT = 15;

    do {
      let path;
      if (!next) {
        path = `${this.basePath}/stores/${this.subscriberId}/reviews?limit=10&orderBy=date%20desc&locale=${this.locale}`;
      } else {
        path = this.basePath + next;
      }

      try {
        const response = await fetch(path);
        if (!response.ok) break;
        const data = await response.json();

        if (Array.isArray(data.reviews)) {
          reviews = reviews.concat(data.reviews);
        }

        next = data.nextUrl;
        fetchedCount = reviews.length;
      } catch (e) {
        console.error('Failed to fetch reviews:', e);
        break;
      }
    } while (next && fetchedCount < SUMMARY_LIMIT);

    return reviews;
  }

  async fetchReviews() {
    if (!this.subscriberId) {
      console.error('Okendo Reviews: No subscriber ID found');
      return;
    }

    let path;
    if (!this.nextUrl) {
      path = `${this.basePath}/stores/${this.subscriberId}/reviews?limit=10&orderBy=date%20desc&locale=${this.locale}`;
    } else {
      path = this.basePath + this.nextUrl;
    }

    try {
      const response = await fetch(path);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      this.nextUrl = data?.nextUrl;

      // If no more reviews available, hide the load more button
      if (!this.nextUrl) {
        this.hideLoadMoreButton();
      }

      if (data.reviews && data.reviews.length > 0) {
        this.handleReviews(data);
        this.hideInitialLoader();
      }
    } catch (error) {
      console.error('Okendo Reviews: Error fetching reviews:', error);
    }
  }

  handleReviews(data) {
    const reviewsData = data;
    const reviewsListElement = document.getElementById(`reviews-list-${this.sectionId}`);

    if (reviewsData?.reviews?.length > 0) {
      const reviews = reviewsData.reviews;
      let totalRating = 0;

      if (!this.nextUrl && reviewsListElement) {
        reviewsListElement.innerHTML = '';
      }

      reviews.forEach((review, index) => {
        const rating = this.getRatingStars(review.rating);
        const date = this.formatDateTimeToLocal(review.dateCreated);
        const verifiedBadge =
          window.okendoCustomSidebarConfig.assets.verifiedBadge +
          window.okendoCustomSidebarConfig.strings.verifiedBadge;
        const reviewerName = review.reviewer?.displayName || 'Anonymous';
        const reviewBody = window.reviewStrings.no_text_rating;
        const media = review.media;
        const reply = review.reply?.body;
        totalRating += review.rating;

        if (reviewsListElement) {
          const modalReviewItem = document.createElement('div');
          modalReviewItem.classList.add('reviews__item');
          modalReviewItem.innerHTML = `
            <div class="review-header">
              <span class="review-header__rating">${rating}</span>
              <span class="review-header__date small-hide">${date}</span>
              <span class="review-header__verified-badge">${verifiedBadge}</span>
            </div>
            <div class="review-user">
              ${window.okendoCustomSidebarConfig.assets.customer}
              ${reviewerName}
            </div>
            <span class="review-header__date medium-hide large-up-hide">${date}</span>
            <div class="review-body">
              ${reviewBody}
            </div>
          `;

          if (media && media.length > 0) {
            const modalReviewMedia = document.createElement('div');
            modalReviewMedia.classList.add('review-media__list');
            media.forEach((mediaItem, mediaIndex) => {
              const mediaElement = document.createElement('img');
              mediaElement.classList.add('review-media__item');
              mediaElement.src = mediaItem.largeUrl;
              mediaElement.alt = `Review Media ${mediaIndex + 1}`;
              modalReviewMedia.appendChild(mediaElement);
            });
            modalReviewItem.appendChild(modalReviewMedia);
          }

          if (reply) {
            const modalReviewReply = document.createElement('div');
            modalReviewReply.classList.add('review-reply');
            modalReviewReply.innerHTML = `
              <div class="review-reply__header">
                <img src="${window.okendoCustomSidebarConfig.assets.logo || ''}" alt="Store Logo" />
                <span>${window.reviewStrings.reply_by_shop_owner || 'Reply from store owner'}</span>
              </div>
              <div class="review-reply__body">${reply}</div>
            `;
            modalReviewItem.appendChild(modalReviewReply);
          }

          reviewsListElement.appendChild(modalReviewItem);

          const divider = document.createElement('div');
          divider.classList.add('review-divider');
          reviewsListElement.appendChild(divider);
        }
      });
    }
  }

  hideLoadMoreButton() {
    const loadMoreContainer = document.getElementById(`reviews-load-more-${this.sectionId}`);
    if (loadMoreContainer) {
      loadMoreContainer.style.display = 'none';
    }
  }

  getRatingStars(rating) {
    let ratingStars = '';
    for (let i = 0; i < rating; i++) {
      ratingStars += `
        <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.04894 0.927049C8.3483 0.00573802 9.6517 0.00574017 9.95106 0.927051L11.2451 4.90983C11.379 5.32185 11.763 5.60081 12.1962 5.60081H16.3839C17.3527 5.60081 17.7554 6.84043 16.9717 7.40983L13.5838 9.87132C13.2333 10.126 13.0866 10.5773 13.2205 10.9894L14.5146 14.9721C14.8139 15.8934 13.7595 16.6596 12.9757 16.0902L9.58778 13.6287C9.2373 13.374 8.7627 13.374 8.41221 13.6287L5.02426 16.0902C4.24054 16.6596 3.18607 15.8934 3.48542 14.9721L4.7795 10.9894C4.91338 10.5773 4.76672 10.126 4.41623 9.87132L1.02827 7.40983C0.244561 6.84043 0.647338 5.60081 1.61606 5.60081H5.8038C6.23703 5.60081 6.62099 5.32185 6.75486 4.90983L8.04894 0.927049Z" fill="#FEC926"/>
        </svg>`;
    }
    return ratingStars;
  }

  formatDateTimeToLocal(isoString) {
    const date = new Date(isoString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  }

  initializeLoadMore() {
    const loadMoreButton = document.getElementById(`LoadMoreReviews-${this.sectionId}`);
    if (loadMoreButton) {
      loadMoreButton.addEventListener('click', () => this.fetchReviews());
    }
  }

  aggregateAttributeRatings(reviews) {
    const attributeMap = {};
    reviews.forEach((review) => {
      if (Array.isArray(review.attributesWithRating)) {
        review.attributesWithRating.forEach((attr) => {
          const key = attr.title;
          if (!attributeMap[key]) {
            attributeMap[key] = {
              title: attr.title,
              minLabel: attr.minLabel,
              maxLabel: attr.maxLabel,
              values: [],
            };
          }
          attributeMap[key].values.push(Number(attr.value));
        });
      }
    });

    return Object.values(attributeMap).map((attr) => ({
      title: attr.title,
      minLabel: attr.minLabel,
      maxLabel: attr.maxLabel,
      average: attr.values.reduce((a, b) => a + b, 0) / attr.values.length,
      count: attr.values.length,
    }));
  }

  displayAttributeRatings(attributeRatings) {
    const attributesContainers = document.querySelectorAll('.rating-attributes');
    if (!attributesContainers || attributesContainers.length === 0) {
      console.warn('No rating attribute containers found on the page');
      return;
    }

    attributesContainers.forEach((attributesContainer) => {
      attributesContainer.innerHTML = '';
      const fragment = document.createDocumentFragment();

      attributeRatings.forEach((attr) => {
        const value = Math.min(Math.max(parseFloat(attr.average) || 0, 0), 5);
        const percentage = (value / 5) * 100;
        const attributeName = attr.title.toLowerCase();
        const labelKey = `attr_${attributeName}_label`;
        const minLabelKey = `attr_${attributeName}_min_label`;
        const maxLabelKey = `attr_${attributeName}_max_label`;

        const attributeElement = document.createElement('div');
        attributeElement.classList.add('rating-attribute');
        attributeElement.innerHTML = `
          <div class="rating-attribute__label subtitle-small">
            ${window.reviewStrings[labelKey] || attr.title}
          </div>
          <div class="rating-attribute__scale">
            <div class="rating-attribute__bar"></div>
            <div class="rating-attribute__marker" style="left: ${percentage}%;"></div>
          </div>
          <div class="rating-attribute__range">
            <span class="rating-attribute__min text-x-small">
              ${window.reviewStrings[minLabelKey] || attr.minLabel}
            </span>
            <span class="rating-attribute__max text-x-small">
              ${window.reviewStrings[maxLabelKey] || attr.maxLabel}
            </span>
          </div>
        `;

        fragment.appendChild(attributeElement);
      });

      attributesContainer.appendChild(fragment);
    });
  }
}

if (!customElements.get('global-reviews')) {
  customElements.define('global-reviews', GlobalReviews);
}
